import { render, staticRenderFns } from "./JinLiXiangLabelDialog.vue?vue&type=template&id=d835a484&scoped=true"
import script from "./JinLiXiangLabelDialog.vue?vue&type=script&lang=js"
export * from "./JinLiXiangLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./JinLiXiangLabelDialog.vue?vue&type=style&index=0&id=d835a484&prod&scoped=true&lang=css"
import style1 from "./JinLiXiangLabelDialog.vue?vue&type=style&index=1&id=d835a484&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d835a484",
  null
  
)

export default component.exports